module.exports = __webpack_public_path__ + "2badeed3a2be35b817e24b841383cf8b.pdf";